export const SKU_LIST_STTU758: string[] = [

    "STTU758-Wh-2XS",
    "STTU758-Wh-XS",
    "STTU758-Wh-S",
    "STTU758-Wh-M",
    "STTU758-Wh-L",
    "STTU758-Wh-XL",
    "STTU758-Wh-2XL",
    "STTU758-Wh-3XL",


    "STTU758-Bl-2XS",
    "STTU758-Bl-XS",
    "STTU758-Bl-S",
    "STTU758-Bl-M",
    "STTU758-Bl-L",
    "STTU758-Bl-XL",
    "STTU758-Bl-2XL",
    "STTU758-Bl-3XL",


    "STTU758-An-2XS",
    "STTU758-An-XS",
    "STTU758-An-S",
    "STTU758-An-M",
    "STTU758-An-L",
    "STTU758-An-XL",
    "STTU758-An-2XL",
    "STTU758-An-3XL",

    "STTU758-FrNa-2XS",
    "STTU758-FrNa-XS",
    "STTU758-FrNa-S",
    "STTU758-FrNa-M",
    "STTU758-FrNa-L",
    "STTU758-FrNa-XL",
    "STTU758-FrNa-2XL",
    "STTU758-FrNa-3XL",

    "STTU758-HeGr-2XS",
    "STTU758-HeGr-XS",
    "STTU758-HeGr-S",
    "STTU758-HeGr-M",
    "STTU758-HeGr-L",
    "STTU758-HeGr-XL",
    "STTU758-HeGr-2XL",
    "STTU758-HeGr-3XL",
]

